/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-const */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/quotes */
import { ChangeDetectorRef, Component, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DomSanitizer } from "@angular/platform-browser";
import { ProgressSpinnerComponent } from "../../progress-spinner/progress-spinner.component";
import { AuditTrailService } from "../audit-trail.service";
import { ViewDocumentComponent } from "../view-document/view-document.component";
// import { data } from "./data";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { animate, state, style, transition, trigger } from "@angular/animations";

export interface Registration {
  id: string;
  qsCode: string;
  ipAddress: string;
  question: string;
  data?: InnerData[] | MatTableDataSource<InnerData>;
}

export interface InnerData {
  ans: string;
  uploadedDocLink: string;
  uploadedDocLinkBack: string;
  ansStatus: string;
  answeredOn: string;
  details: string;
}

export interface RegistrationDataSource {
  id: string;
  qsCode: string;
  ipAddress: string;
  question: string;
  data?: MatTableDataSource<InnerData>;
}
@Component({
  selector: "app-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
    ]),
  ],
})
export class RegistrationComponent implements OnInit {
  filterOptions: any[] = [];
  selectedFilterOption: any = null;

  panNumberTextFieldVisible: boolean = false;
  userDropdownVisible: boolean = false;

  panNo: string = "";
  regId: string = "";

  users: any[] = [];
  selectedUser: any = null;

  auditTrailLogs: any[] = [];
  progressSpinnerDialog: any;
  constructor(
    private auditTrailService: AuditTrailService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private changeDetectorRefs: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.setFilterOptions();
  }

  @ViewChild("outerSort", { static: true }) sort: MatSort;
  @ViewChildren("innerSort") innerSort: QueryList<MatSort>;
  @ViewChildren("innerTables") innerTables: QueryList<MatTable<InnerData>>;

  dataSource: MatTableDataSource<Registration>;
  usersData: any[] = [];
  columnsToDisplay = ["question", "ipAddress"];
  innerDisplayedColumns = ["ans", "uploadedDocLink", "uploadedDocLinkBack", "ansStatus", "answeredOn", "details"];
  expandedElement: any | null;
  columnsToDisplayWithExpand = [...this.columnsToDisplay, "expand"];

  toggleRow(element: any) {
    console.log(element);

    element.addresses && (element.addresses as MatTableDataSource<InnerData>).data.length
      ? (this.expandedElement = this.expandedElement === element ? null : element)
      : null;
    this.changeDetectorRefs.detectChanges();
    this.innerTables.forEach(
      (table, index) => ((table.dataSource as MatTableDataSource<InnerData>).sort = this.innerSort.toArray()[index])
    );
  }

  applyFilter(filterValue: string) {
    this.innerTables.forEach(
      (table, index) => ((table.dataSource as MatTableDataSource<InnerData>).filter = filterValue.trim().toLowerCase())
    );
  }

  async setFilterOptions() {
    this.filterOptions = await [
      { label: "PAN Number", value: 1 },
      { label: "Name", value: 2 },
      { label: "Both", value: 0 },
    ];
  }

  filterOptionSelect() {
    if (this.selectedFilterOption.value == 1) {
      this.panNumberTextFieldVisible = true;
      this.userDropdownVisible = false;
    } else if (this.selectedFilterOption.value == 2) {
      this.userDropdownVisible = true;
      this.panNumberTextFieldVisible = false;
    } else if (this.selectedFilterOption.value == 0) {
      this.panNumberTextFieldVisible = true;
      this.userDropdownVisible = true;
    }
  }

  userDetails: any[] = [];
  photo: string = "";
  async getAuditTrailReport() {
    const progressSpinnerDialog = await this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
    this.auditTrailLogs = [];
    this.userDetails = [];
    this.dataSource = new MatTableDataSource();
    this.usersData = [];
    let panNumber: any = "0";
    let regId: any = "0";
    if (this.panNo.match(/^\d+$/)) {
      console.log("numeric");
      panNumber = "";
      regId = this.panNo;
    } else {
      console.log("alpha");
      panNumber = this.panNo.toUpperCase();
      regId = "null";
    }
    await this.auditTrailService
      .getRecordsByCriteriaV2(this.selectedUser, panNumber, regId)
      .subscribe((response: any) => {
        console.log(response);
        progressSpinnerDialog.close();
        if (!response.error) {
          if (response?.page.length > 0) {

            this.regId = response.regId;

            response.page.forEach((user) => {
              if (user.data && Array.isArray(user.data) && user.data.length) {
                this.usersData = [...this.usersData, { ...user, addresses: new MatTableDataSource(user.data) }];
              } else {
                this.usersData = [...this.usersData, user];
              }
            });
            this.dataSource = new MatTableDataSource(this.usersData);
            this.dataSource.sort = this.sort;
            // this.auditTrailLogs = response;
            // for (let i = 0; i < this.auditTrailLogs.length; i++) {
            //   if (this.auditTrailLogs[i]["autCategory"] == "DIGI_LOCKER") {
            //     this.userDetails.push(this.auditTrailLogs[i]["autSelfAadharDesc"][0]);
            //   }
            // }
            // console.log(this.userDetails);
          } else {
            this.warningToast("No data available.");
          }
        } else {
          this.errorToast();
        }
      });
  }

  async viewPreuploadImages(document: any, docUrl: any) {
    console.log(document);
    console.log(docUrl);
    if (docUrl.split(".").pop() == "pdf") {
      // window.open(docUrl, "_blank");
      await this.auditTrailService.downloadFileV1(docUrl.split("/").pop(), this.regId).subscribe((response: any) => {
        if (response != null && !response.error) {
          let file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
      });
    } else {
      // let imageBackUrl: any = null;
      // let image = docUrl.split(",");
      // if (document.rsaDocumentLocationBack || document.rspaDocumentLocationBack) {
      //   let doc = "";
      //   if (document.rsaDocumentLocationBack) {
      //     doc = document.rsaDocumentLocationBack;
      //   } else {
      //     doc = document.rspaDocumentLocationBack;
      //   }
      //   const response: any = await this.auditTrailService.downloadFile(doc);
      //   if (response != null && !response.error) {
      //     let file = new Blob([response], { type: "image/*" });
      //     var fileURL = URL.createObjectURL(file);
      //     imageBackUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
      //   }
      // }
      await this.auditTrailService.downloadFileV1(docUrl.split("/").pop(),this.regId).subscribe((response: any) => {
        if (response != null && !response.error) {
          var binary = "";
          var bytes = new Uint8Array(response);
          var len = bytes.byteLength;
          for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          let url = window.btoa(binary);

          let file = new Blob([response], { type: "image/*" });
          var fileURL = URL.createObjectURL(file);
          setTimeout(() => {
            let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            const dialog = this.dialog.open(ViewDocumentComponent, {
              disableClose: false,
              width: "600px",
              data: this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url),
            });
          }, 100);
        }
      });
    }
  }

  async warningToast(message: string) {
    await this._snackBar.open(message, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = await this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  async downloadReport() {
    this.displayProgressSpinner();
    await this.auditTrailService.exportAuditTrailReportV1(this.panNo.toUpperCase()).subscribe(async (response: any) => {
      console.log(response);
      this.progressSpinnerDialog.close();
      if (response != "Failure") {
        await this.auditTrailService.downloadFileV1(response.split("/").pop(),this.regId).subscribe((blob: any) => {
          let file = new Blob([blob], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
      } else {
        this.warningToast("Unable to download report;");
      }
    });
  }

  buttonDisabled: boolean = true;
  checkInput(inputValue: string): void {
    if (/^[a-zA-Z]/.test(inputValue)) {
      console.log("Input starts with a character");
      const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
      if (panRegex.test(inputValue)) {
        console.log("Valid PAN number");
        this.buttonDisabled = false;
      } else {
        console.log("Invalid PAN number");
        this.buttonDisabled = true;
      }
    } else if (/^\d/.test(inputValue)) {
      const numberRegex = /^\d+$/;
      if (numberRegex.test(inputValue)) {
        console.log("Input starts with a number and contains numbers throughout");
        this.buttonDisabled = false;
      } else {
        console.log("Input starts with a number but contains non-numeric characters");
        this.buttonDisabled = true;
      }
    } else {
      console.log("Input does not start with a character or number");
      this.buttonDisabled = true;
    }
  }
}
